import { render, staticRenderFns } from "./tab5.vue?vue&type=template&id=c96a64ea&scoped=true&"
import script from "./tab5.vue?vue&type=script&lang=js&"
export * from "./tab5.vue?vue&type=script&lang=js&"
import style0 from "./tab5.vue?vue&type=style&index=0&id=c96a64ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c96a64ea",
  null
  
)

export default component.exports